export function GettingRoleID(Name) {
  const LocalStorageDetail = window.localStorage.getItem('roles');
  const roles = JSON.parse(LocalStorageDetail || null);
  const getRoleOFVendor = roles.find((item) => item.role === Name);
  return getRoleOFVendor.id;
}
